import { Link } from "react-router-dom"
import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { ArrowLeft, Shield } from "lucide-react"
import { PublicFooter } from "@/components/lgpd/Footer"

const S = ({ t, children }: { t: string; children: React.ReactNode }) => (
  <Card><CardContent className="p-6">
    <h2 className="text-xl font-bold mb-3">{t}</h2>
    <div className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed space-y-2">{children}</div>
  </CardContent></Card>
)

const PoliticaPrivacidade = () => (
  <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
    <header className="bg-white dark:bg-slate-800 border-b">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="font-bold text-lg">itaCondo</Link>
        <Link to="/"><Button variant="outline" size="sm"><ArrowLeft className="h-4 w-4 mr-1" /> Voltar</Button></Link>
      </div>
    </header>

    <main className="container mx-auto px-4 py-12 max-w-3xl space-y-6">
      <div className="text-center mb-4">
        <div className="inline-flex w-16 h-16 rounded-full bg-blue-100 items-center justify-center mb-4">
          <Shield className="h-8 w-8 text-blue-600" />
        </div>
        <h1 className="text-3xl md:text-4xl font-bold">Política de Privacidade</h1>
        <p className="text-sm text-slate-500 mt-2">Versão 2026-05-25 — em conformidade com a LGPD (Lei 13.709/2018)</p>
      </div>

      <S t="1. Quem somos">
        <p>O <strong>itaCondo</strong> é uma plataforma SaaS de gestão para condomínios, controle de ponto e controle de acesso. Atuamos como <strong>Operador</strong> de dados pessoais — o condomínio contratante é o <strong>Controlador</strong>.</p>
      </S>
      <S t="2. Dados que coletamos">
        <ul className="list-disc pl-5 space-y-1">
          <li>Identificação: nome, e-mail, telefone, WhatsApp, CPF (quando aplicável), foto.</li>
          <li>Endereço: bloco/apartamento.</li>
          <li>Acesso: credenciais, IP, navegador, registros de login.</li>
          <li>Operacionais: visitantes, encomendas, ocorrências, mensagens, agendamentos, registros de ponto.</li>
          <li>Cookies: necessários, funcionais, analíticos e marketing (com consentimento).</li>
        </ul>
      </S>
      <S t="3. Bases legais (art. 7º LGPD)">
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Execução de contrato</strong>: prestação do serviço.</li>
          <li><strong>Consentimento</strong>: comunicações de marketing, cookies opcionais.</li>
          <li><strong>Cumprimento de obrigação legal</strong>: folha de ponto (CLT, 5 anos), dados fiscais.</li>
          <li><strong>Legítimo interesse</strong>: segurança patrimonial (visitantes), prevenção a fraudes.</li>
        </ul>
      </S>
      <S t="4. Compartilhamento">
        <p>Compartilhamos dados com sub-operadores estritamente necessários: <strong>Supabase</strong> (hospedagem/banco), <strong>Resend</strong> (e-mails), <strong>Jitsi</strong> (videoconferência) e provedores de notificação WhatsApp/Push. Não vendemos dados.</p>
      </S>
      <S t="5. Transferência internacional">
        <p>Parte da infraestrutura está nos EUA. Adotamos cláusulas contratuais e salvaguardas técnicas para garantir nível adequado de proteção (art. 33 LGPD).</p>
      </S>
      <S t="6. Retenção">
        <ul className="list-disc pl-5 space-y-1">
          <li>Visitantes: 300 dias, depois anonimizados.</li>
          <li>Logs de acesso: 12 meses.</li>
          <li>Mensagens: 24 meses.</li>
          <li>Ponto eletrônico: 5 anos (CLT).</li>
          <li>Dados financeiros: 5 anos.</li>
        </ul>
      </S>
      <S t="7. Seus direitos (art. 18)">
        <p>Você pode: confirmar tratamento, acessar, corrigir, anonimizar/excluir, portar, revogar consentimento, opor-se e reclamar à ANPD. Exerça em <Link to="/configuracoes" className="text-blue-600 underline">Configurações → Privacidade e Dados</Link> ou via <Link to="/encarregado-de-dados" className="text-blue-600 underline">Encarregado</Link>.</p>
      </S>
      <S t="8. Segurança (art. 46)">
        <p>Criptografia em trânsito (HTTPS) e em repouso, RLS multi-tenant, controle de acesso por perfil, auditoria e backups.</p>
      </S>
      <S t="9. Incidentes (art. 48)">
        <p>Comunicaremos titulares e a ANPD em prazo razoável caso ocorra incidente de segurança com risco relevante.</p>
      </S>
      <S t="10. Encarregado (DPO)">
        <p>E-mail: <a href="mailto:contatoitacondo@gmail.com" className="text-blue-600 underline">contatoitacondo@gmail.com</a> · <Link to="/encarregado-de-dados" className="text-blue-600 underline">formulário</Link>.</p>
      </S>
      <S t="11. Atualizações">
        <p>Esta Política pode ser atualizada. Mudanças relevantes serão comunicadas no sistema. Versão atual: 2026-05-25.</p>
      </S>
    </main>

    <PublicFooter />
  </div>
)

export default PoliticaPrivacidade
